import { FunctionComponent, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { CatalogTile } from "../config/tileCatalog";
import { CatalogAvailabilityContext } from "../utils/catalogAvailability";
import { groupCatalogTilesByPrimaryCategory } from "../utils/catalogGrouping";
import { CatalogGrid } from "./CatalogGrid";

interface CatalogSectionsProps {
	tiles: CatalogTile[];
	highlightedTileId?: string | null;
	availabilityContext: CatalogAvailabilityContext;
	isFavorite?: (id: string) => boolean;
	isBusy?: boolean;
	onToggleFavorite?: (tile: CatalogTile) => void;
	onSelectTile: (tile: CatalogTile) => void;
}

export const CatalogSections: FunctionComponent<CatalogSectionsProps> = ({
	tiles,
	highlightedTileId,
	availabilityContext,
	isFavorite,
	isBusy = false,
	onToggleFavorite,
	onSelectTile,
}) => {
	const { t } = useTranslation();
	const sections = useMemo(() => groupCatalogTilesByPrimaryCategory(tiles), [tiles]);

	return (
		<div className="flex flex-col gap-8">
			{sections.map((section) => (
				<section key={section.category}>
					<div className="mb-3 flex items-baseline gap-2.5">
						<h2 className="text-sm font-semibold text-text">
							{t(`list.create.catalog.rail.categories.${section.category}`)}
						</h2>
						<span className="min-w-0 flex-1 truncate text-xs text-text-disabled">
							{t(`list.create.catalog.sectionDescriptions.${section.category}`)}
						</span>
					</div>
					<CatalogGrid
						availabilityContext={availabilityContext}
						highlightedTileId={highlightedTileId}
						isBusy={isBusy}
						isFavorite={isFavorite}
						tiles={section.tiles}
						onSelectTile={onSelectTile}
						onToggleFavorite={onToggleFavorite}
					/>
				</section>
			))}
		</div>
	);
};
